/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { Button, Grid, Input, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Autocomplete } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import SearchSelect from 'react-select';
import ListItemText from '@mui/material/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { useJsApiLoader, StandaloneSearchBox } from '@react-google-maps/api';
import Checkbox from '@material-ui/core/Checkbox';
import Service from '../../apis/service';
import GetDealerships from '../../apis/GetDealerships';
import Theme from '../ui/Theme';
import Modal from '../common/Modal';
import 'react-toastify/dist/ReactToastify.css';

import { getDealershipList, getPlanList, showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, hasNumbers, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import MultiSelectSearch from '../common/search/MultiSelectSearch';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { cleanObject, customFilter } from './utils';
import useFetchDetails from './hooks/useFetchDetails';
import GoogleMap from '../common/GoogleMap';
import { timeZones } from './constant';
import AddNewTag from './AddNewTag';
import DealershipExternalProfileCard from './components/DealershipExternalProfileCard';
import PreferedBrands from './components/PreferedBrands';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    maxHeight: '58vh',
    overflow: 'scroll',
  },
  btnStylemewtag: {
    background: Theme.palette.primary.main,
    marginBottom: '10px',
    cursor: 'pointer',
    padding: '2px',
    color: Theme.palette.secondary.main,
  },
  required_field: {
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  listTextSelected: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '17px',
    fontStyle: 'normal',
  },
  listTextNonSelected: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '17px',
    fontStyle: 'normal',
  },
  listSubTextSelected: {
    color: Theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    marginTop: '5px',
  },
  listSubTextNonSelected: {
    color: 'rgba(0, 0, 0, 0.4)',
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    marginTop: '5px',
  },
  highlightItem: {
    borderRight: `4px solid ${Theme.palette.primary.main}`,
  },
  nonHighlightItem: {},

  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
    paddingLeft: '18px',
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginTop: 0,

    paddingLeft: '18px',
  },
  popupInputContainer: {
    textAlign: 'left',
    padding: '18px',
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  popInputs: {
    border: 0,
    outline: 0,
    backgroundColor: Theme.palette.secondary.main,
    height: '45px',
    width: '375px',
    padding: '0 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    '&:placeholder': {
      color: '#4b4b4b',
      opacity: '1',
    },
  },

  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
    marginRight: '28px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  parentDealershipField: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
  },
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '270px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  buttonContainer: {
    position: 'fixed',
    bottom: '28px',
    background: '#fff',
    padding: '10px',
    width: '900px',
    zIndex: '1',
  },
}));

export const DealershipAddnewPopup = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { fetchDetails, fetchTags } = useFetchDetails();
  const isAdd = props.add;
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const dealershipDetails = useSelector((state) => state.DealershipDetails.dealershipdetails);
  const planList = useSelector((state) => state.GetPlanList.planlist)?.map((i) => ({ value: i.id, label: i.title }));
  const tagList = useSelector((state) => state.getTagsForDealership.dealershipTags);
  const dealershipID = useSelector((state) => state.getDealershipID);
  const [data, setData] = useState({});
  const [dataObj, setDataObj] = useState({});
  const [viewDealershipPop, setViewDealershipPop] = useState(props.open);
  const [pipelineStatus, setPipelineStatus] = useState([]);
  const [pxOwnerList, setPxOwnerList] = useState([]);
  const [masterDataCleanupDropdowns, setMasterDataCleanupDropdowns] = useState([]);
  const [tags, setTags] = useState([]);
  const [openAddTag, setOpenAddTag] = useState(false);
  const [selectedPlans, setSelectedPlans] = useState([]);

  const [dealershipList, setDealershipList] = useState([]);
  const defaultParentDealership = { value: 0, label: 'Please select a parent dealership', hubspotId: 0 };

  const addressInputRef = useRef(null);
  const [location, setLocation] = useState(null);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries: ['places'],
  });

  const handleOnPlacesChanged = async () => {
    const places = addressInputRef.current.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      const getComponent = (type) =>
        addressComponents.find((component) => component.types.includes(type))?.long_name || '';

      // eslint-disable-next-line prefer-destructuring, no-shadow
      const location = place.geometry.location;
      const lat = location.lat();
      const lng = location.lng();

      // Fetch timezone using Time Zone API
      // const timezone = await fetchTimezone(lat, lng);

      const city = getComponent('locality');
      const state = getComponent('administrative_area_level_1');
      const zip = getComponent('postal_code');
      const country = getComponent('country');
      const add = place.formatted_address || '';
      setData((pre) => ({
        ...pre,
        city,
        address: add,
        state,
        country,
        pinCode: zip,
      }));
      setLocation({ lat, lng });
    }
  };

  useEffect(() => {
    fetchPlans();
    fetchParentDealerships();
    fetchLeadpipelineStatus();
    fetchPxOwnerList();
    fetchMasterCleanupData();
    fetchTags();
  }, []);

  useEffect(() => {
    if (!isAdd) {
      const tempDealershipDetails = cleanObject(dealershipDetails);
      setData(() => ({
        ...tempDealershipDetails,
        planIds: dealershipDetails?.plans?.map((plan) => plan.id) || [],
        accountTypeId: dealershipDetails?.accountType?.id || null,
        segmentId: dealershipDetails?.segment?.id || null,
        locationTypeId: dealershipDetails?.locationType?.id || null,
        launchMilestoneId: dealershipDetails?.launchMilestone?.id || null,
        organizationSizeId: dealershipDetails?.organizationSize?.id || null,
        lifeCycleStageId: dealershipDetails?.lifeCycleStage?.id || null,
        tagIds: dealershipDetails?.tags?.map((tag) => tag.id) || [],
        domainList: dealershipDetails?.domainList?.join(','),
        metaData: dealershipDetails?.metaData || [],
        preferredBrands: dealershipDetails?.preferredBrands || [],
      }));
      setTags(dealershipDetails?.tags || []);
      setDataObj((prev) => ({
        ...prev,
        segmentId: {
          value: dealershipDetails?.segment?.id,
          label: dealershipDetails?.segment?.title,
        },
        locationTypeId: {
          value: dealershipDetails?.locationType?.id,
          label: dealershipDetails?.locationType?.title,
        },
        accountTypeId: {
          value: dealershipDetails?.accountType?.id,
          label: dealershipDetails?.accountType?.title,
        },
        launchMilestoneId: {
          value: dealershipDetails?.launchMilestone?.id,
          label: dealershipDetails?.launchMilestone?.title,
        },
        organizationSizeId: {
          value: dealershipDetails?.organizationSize?.id,
          label: dealershipDetails?.organizationSize?.title,
        },
        lifeCycleStageId: {
          value: dealershipDetails?.lifeCycleStage?.id,
          label: dealershipDetails?.lifeCycleStage?.title,
        },
        parentDealershipId: {
          value: dealershipDetails?.parentDealership?.id,
          label: dealershipDetails?.parentDealership?.name,
          hubspotId: dealershipDetails?.parentDealership?.hubspotId,
        },
        pxOwnerHash: { value: dealershipDetails?.pxOwnerHash, label: dealershipDetails?.pxOwnerName },
      }));

      const selectedOptions = dealershipDetails?.plans?.map((item) => ({
        label: item.title,
        value: item.id,
      }));
      setSelectedPlans(selectedOptions);
    }
  }, [dealershipDetails, isAdd]);

  const fetchPlans = async () => {
    dispatch(showProgress(true));
    const payload = '';
    await Service.get(apiEndpoints.GET_PLANS, payload)
      .then((response) => {
        dispatch(getPlanList('fetch', response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const fetchLeadpipelineStatus = async () => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.DEALER_SALES_PIPELINE)
      .then((response) => {
        setPipelineStatus(response);
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const fetchPxOwnerList = async () => {
    dispatch(showProgress(true));
    try {
      const response = await Service.get(apiEndpoints.DEALER_PX_OWNERS);
      setPxOwnerList(response?.map((i) => ({ value: i.hash, label: i.name })) || []);
      if (!isAdd && !_isEmpty(response)) {
        const temp = response.find((i) => i.hash === dealershipDetails.pxOwnerHash);
        setData((prev) => ({ ...prev, pxOwnerHash: temp?.hash }));
      }
    } catch (err) {
      console.log(err);
    }
    dispatch(showProgress(false));
  };

  const fetchMasterCleanupData = async () => {
    dispatch(showProgress(true));
    try {
      const response = await Service.get(apiEndpoints.DEALER_MASTER_CEANUP_DROPDOWNS);
      setMasterDataCleanupDropdowns(response || []);
    } catch (err) {
      console.log(err);
    }
    dispatch(showProgress(false));
  };

  const fetchParentDealerships = async () => {
    dispatch(showProgress(true));
    const payload = '';
    await Service.get(apiEndpoints.DEALER_PARENT_DEALERSHIP.replace('DEALER_ID', dealershipID), payload)
      .then((response) => {
        const tempArr = [defaultParentDealership];
        response?.forEach((deal) => tempArr.push({ value: deal.id, label: deal.name, hubspotId: deal.hubspotId }));
        setDealershipList(tempArr);
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const closePopup = () => {
    setViewDealershipPop(false);
    props.close();
  };

  const onClickAddNewDealer = async () => {
    const check = validateForm();
    if (check) {
      const payload = cleanObject(data);
      const fetchDataList = async () => {
        const dealershipsData = await GetDealerships();
        dispatch(getDealershipList('get', dealershipsData));
      };
      if (isAdd) {
        dispatch(showProgress(true));
        await Service.post(apiEndpoints.GET_DEALERSHIPS, payload)
          .then((response) => {
            notifySuccess('Dealership Saved Successfully');
            props.getSelect('event', response.id);

            closePopup();
            fetchDataList();
            dispatch(showProgress(false));
          })
          .catch((error) => {
            ErrorToast(error);
            dispatch(showProgress(false));
          });
      } else {
        dispatch(showProgress(true));
        await Service.put(apiEndpoints.DEALER_BY_ID.replace('ID', dealershipDetails.id), payload)
          .then(() => {
            setViewDealershipPop(false);
            fetchDataList();
            fetchDetails();
            notifySuccess('Dealership Saved Successfully');
            closePopup();
            dispatch(showProgress(false));
          })
          .catch((error) => {
            ErrorToast(error);
            dispatch(showProgress(false));
          });
      }
    }
  };

  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (typeof data?.primaryContactNumber !== 'undefined' && data?.primaryContactNumber) {
      const regex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
      if (!data?.primaryContactNumber || !regex.test(data?.primaryContactNumber)) {
        formIsValid = false;
        errors.push('Please enter valid mobile nos.');
      }
    }
    if (hasNumbers(data?.primaryContactName)) {
      formIsValid = false;
      errors.push('Please enter valid contact name.');
    }
    if (data?.planIds?.length <= 0 || !data?.planIds) {
      formIsValid = false;
      errors.push('Please select at least one plan');
    }
    if (_isEmpty(data?.pxOwnerHash)) {
      formIsValid = false;
      errors.push('Please select a PX owner');
    }
    if (!dataObj?.accountTypeId?.value) {
      formIsValid = false;
      errors.push('Please select an account type.');
    }
    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };

  const formatOptionLabel = ({ label, hubspotId: hub }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div className={classes.ellipsisMessage}>{label}</div>
      {hub && data?.parentDealership?.hubspotId !== hub ? <div>{hub}</div> : null}
    </div>
  );
  const onTagSelect = (event, value) => {
    const tempSelected = value?.map((val) => val?.id);
    setData((prev) => ({ ...prev, tagIds: [...tempSelected] }));
  };
  const handleDataChange = ({ target: { value, name, type, checked } }) => {
    setData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleMultiSelect = (selectedOptions) => {
    setData((prev) => ({
      ...prev,
      planIds: selectedOptions.map((option) => option.value),
    }));
    setSelectedPlans(selectedOptions);
  };

  const handleSearchSelect = (valueObj, nameObj) => {
    setData((prev) => ({ ...prev, [nameObj?.name]: valueObj?.value }));
    setDataObj((prev) => ({ ...prev, [nameObj?.name]: valueObj }));
  };
  const openAddTagPopup = () => {
    setOpenAddTag(true);
  };
  const handleCloseAddNewTag = () => {
    setOpenAddTag(false);
  };
  return (
    <Modal isOpen={viewDealershipPop} height="90vh" width="900px">
      <div>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={11}>
            <p className={classes.popupHeading}>{isAdd ? 'Adding New' : 'Edit'} Dealership</p>
          </Grid>
          <Grid item xs={1}>
            <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
          </Grid>
        </Grid>
        <Grid container direction="column">
          <Grid item>
            <Grid container>
              <Grid item xs={6} className={classes.popupInputContainer}>
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    Dealership Name
                  </label>
                </div>

                <input
                  type="text"
                  id="dealership"
                  required
                  autoComplete="off"
                  autoSave="off"
                  name="name"
                  value={data?.name}
                  className={classes.popInputs}
                  onChange={handleDataChange}
                />

                <div className={classes.popupLabels}>
                  <label htmlFor="address" className={classes.required_field}>
                    Address
                  </label>
                </div>
                {isLoaded && (
                  <StandaloneSearchBox
                    onLoad={(ref) => {
                      addressInputRef.current = ref;
                    }}
                    onPlacesChanged={handleOnPlacesChanged}
                  >
                    <input
                      name="address"
                      type="text"
                      id="address"
                      autoComplete="off"
                      autoSave="off"
                      className={classes.popInputs}
                      value={data?.address}
                      onChange={handleDataChange}
                    />
                  </StandaloneSearchBox>
                )}
                {location && (
                  <div style={{ margin: '2px 0px 20px' }}>
                    <GoogleMap location={location} width="390px" height="130px" />
                  </div>
                )}

                <div className={classes.popupLabels}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    City
                  </label>
                </div>
                <input
                  name="city"
                  type="text"
                  className={classes.popInputs}
                  autoComplete="off"
                  autoSave="off"
                  value={data?.city}
                  onChange={handleDataChange}
                />
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    Country
                  </label>
                </div>
                <input
                  name="country"
                  type="text"
                  autoComplete="off"
                  autoSave="off"
                  className={classes.popInputs}
                  value={data?.country}
                  onChange={handleDataChange}
                />
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    Zipcode
                  </label>
                </div>
                <input
                  name="pinCode"
                  type="text"
                  autoComplete="off"
                  autoSave="off"
                  className={classes.popInputs}
                  value={data?.pinCode}
                  onChange={handleDataChange}
                />
                <Grid item>
                  <div className={classes.popupLabels}>
                    <label htmlFor="dealership" className={classes.required_field}>
                      State
                    </label>
                  </div>
                  <input
                    name="state"
                    type="text"
                    autoComplete="off"
                    autoSave="off"
                    className={classes.popInputs}
                    value={data?.state}
                    onChange={handleDataChange}
                  />
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels}>
                    <label htmlFor="dealership" className={classes.required_field}>
                      Timezone
                    </label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <Select
                      name="timezone"
                      labelId="multiple-checkbox-label"
                      id="multiple-checkbox"
                      value={data?.timezone}
                      onChange={handleDataChange}
                      input={<Input disableUnderline className={classes.popInputs} />}
                      MenuProps={MenuProps}
                    >
                      {timeZones?.map((option) => (
                        <MenuItem name={option.name} value={option.value}>
                          <ListItemText primary={option.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels}>
                    <label htmlFor="dealership" className={classes.required_field}>
                      sales pipeline status
                    </label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <Select
                      name="leadPipeline"
                      labelId="multiple-checkbox-label"
                      id="multiple-checkbox"
                      value={data?.leadPipeline}
                      onChange={handleDataChange}
                      input={<Input disableUnderline className={classes.popInputs} />}
                      MenuProps={MenuProps}
                    >
                      {pipelineStatus?.map((option, key) => (
                        <MenuItem key={option.id} name={option.id} value={key + 1}>
                          <ListItemText primary={option.title} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership">chargify id</label>
                </div>
                <input
                  name="chargifyId"
                  type="text"
                  autoComplete="off"
                  autoSave="off"
                  className={classes.popInputs}
                  value={data?.chargifyId}
                  onChange={handleDataChange}
                />
                <Grid item>
                  <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                    <label htmlFor="dealership">Launch Milestones</label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <SearchSelect
                      name="launchMilestoneId"
                      placeholder="Select Launch Milestone"
                      value={dataObj?.launchMilestoneId}
                      onChange={handleSearchSelect}
                      isClearable
                      options={masterDataCleanupDropdowns.launchMilestones}
                      formatOptionLabel={formatOptionLabel}
                      filterOption={customFilter}
                      className={classes.parentDealershipField}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#f4f4f4',
                        }),
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                    <label htmlFor="dealership">Organisation Size</label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <SearchSelect
                      name="organizationSizeId"
                      placeholder="Select Organization Size "
                      value={dataObj?.organizationSizeId}
                      onChange={handleSearchSelect}
                      isClearable
                      options={masterDataCleanupDropdowns.organizationSizes}
                      formatOptionLabel={formatOptionLabel}
                      filterOption={customFilter}
                      className={classes.parentDealershipField}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#f4f4f4',
                        }),
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                    <label htmlFor="dealership" className={classes.required_field}>
                      PX Owner
                    </label>
                  </div>
                  <FormControl style={{ marginTop: '15px' }}>
                    <SearchSelect
                      name="pxOwnerHash"
                      placeholder="Select PX Owner"
                      value={dataObj?.pxOwnerHash}
                      onChange={handleSearchSelect}
                      options={pxOwnerList}
                      className={classes.parentDealershipField}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#f4f4f4',
                        }),
                      }}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={6} className={classes.popupInputContainer}>
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    Email Domain Name
                  </label>
                </div>
                <input
                  name="domainList"
                  type="text"
                  autoComplete="off"
                  autoSave="off"
                  className={classes.popInputs}
                  value={data?.domainList}
                  placeholder="Example: domain1.com, domain2.com"
                  onChange={handleDataChange}
                />
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    Primary Contact Name
                  </label>
                </div>
                <input
                  name="primaryContactName"
                  type="text"
                  autoComplete="off"
                  autoSave="off"
                  className={classes.popInputs}
                  value={data?.primaryContactName}
                  onChange={handleDataChange}
                />
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    Primary Contact Number
                  </label>
                </div>
                <input
                  name="primaryContactNumber"
                  type="text"
                  autoComplete="off"
                  autoSave="off"
                  className={classes.popInputs}
                  value={data?.primaryContactNumber}
                  onChange={handleDataChange}
                />
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    Primary Contact Email
                  </label>
                </div>
                <input
                  name="primaryContactEmail"
                  type="email"
                  autoComplete="off"
                  autoSave="off"
                  className={classes.popInputs}
                  value={data?.primaryContactEmail}
                  onChange={handleDataChange}
                />
                <Grid item>
                  <div className={classes.popupLabels}>
                    <label htmlFor="dealership" className={classes.required_field}>
                      Plan
                    </label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <MultiSelectSearch
                      name="planIds"
                      placeholderButtonLabel="Select a Dealership Plan"
                      selectedOptions={selectedPlans}
                      onChange={handleMultiSelect}
                      options={planList || []}
                      width="395px"
                      showSubtext
                    />
                  </FormControl>
                </Grid>
                <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                  <label htmlFor="dealership" className={classes.required_field}>
                    Hubspot ID
                  </label>
                </div>
                <input
                  name="hubspotId"
                  type="text"
                  autoComplete="off"
                  autoSave="off"
                  className={classes.popInputs}
                  value={data?.hubspotId}
                  onChange={handleDataChange}
                />
                <Grid item>
                  <div className={classes.popupLabels}>
                    <label htmlFor="dealership">parent dealership</label>
                  </div>
                  <FormControl style={{ marginTop: '15px' }}>
                    <SearchSelect
                      name="parentDealershipId"
                      placeholder="Select Parent Dealerships"
                      value={dataObj?.parentDealershipId}
                      onChange={handleSearchSelect}
                      isClearable
                      options={dealershipList}
                      formatOptionLabel={formatOptionLabel}
                      filterOption={customFilter}
                      className={classes.parentDealershipField}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#f4f4f4',
                        }),
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                    <label htmlFor="dealership">Segment</label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <SearchSelect
                      name="segmentId"
                      placeholder="Select Parent Dealerships"
                      value={dataObj?.segmentId}
                      onChange={handleSearchSelect}
                      isClearable
                      options={masterDataCleanupDropdowns.segments}
                      formatOptionLabel={formatOptionLabel}
                      filterOption={customFilter}
                      className={classes.parentDealershipField}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#f4f4f4',
                        }),
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                    <label htmlFor="dealership" className={classes.required_field}>
                      Account Type
                    </label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <SearchSelect
                      name="accountTypeId"
                      placeholder="Select Parent Dealerships"
                      value={dataObj?.accountTypeId}
                      onChange={handleSearchSelect}
                      isClearable
                      options={masterDataCleanupDropdowns.accountTypes}
                      formatOptionLabel={formatOptionLabel}
                      filterOption={customFilter}
                      className={classes.parentDealershipField}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#f4f4f4',
                        }),
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                    <label htmlFor="dealership">Location Type</label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <SearchSelect
                      name="locationTypeId"
                      placeholder="Select Location Type"
                      value={dataObj?.locationTypeId}
                      onChange={handleSearchSelect}
                      isClearable
                      options={masterDataCleanupDropdowns.locationTypes}
                      formatOptionLabel={formatOptionLabel}
                      filterOption={customFilter}
                      className={classes.parentDealershipField}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#f4f4f4',
                        }),
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                    <label htmlFor="dealership">Life Cycle Stage </label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <SearchSelect
                      name="lifeCycleStageId"
                      placeholder="Select Life Cycle Stage"
                      value={dataObj?.lifeCycleStageId}
                      onChange={handleSearchSelect}
                      isClearable
                      options={masterDataCleanupDropdowns.lifeCycleStages}
                      formatOptionLabel={formatOptionLabel}
                      filterOption={customFilter}
                      className={classes.parentDealershipField}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#f4f4f4',
                        }),
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <div className={classes.popupLabels} style={{ marginTop: '15px' }}>
                    <label htmlFor="dealership"> Tags</label>
                  </div>
                  <FormControl style={{ marginTop: '5px' }}>
                    <Grid container direction="row">
                      <Grid item xs={11}>
                        <Autocomplete
                          multiple
                          id="multiple-limit-tags"
                          options={tagList || []}
                          getOptionLabel={(option) => option.title}
                          isOptionEqualToValue={(op, val) => op.id === val.id}
                          defaultValue={tags}
                          filterSelectedOptions
                          renderInput={(params) => <TextField {...params} placeholder="Tags" disableUnderline />}
                          onChange={onTagSelect}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <AddIcon className={classes.btnStylemewtag} onClick={openAddTagPopup} />
                      </Grid>
                      {openAddTag && <AddNewTag open type="dealership" close={handleCloseAddNewTag} />}
                    </Grid>
                  </FormControl>
                </Grid>

                <Grid item>
                  <FormControlLabel
                    style={{ marginTop: '18px' }}
                    control={
                      <Checkbox
                        name="enabled"
                        checked={data?.enabled}
                        onChange={handleDataChange}
                        value={data?.enabled}
                        color="primary"
                      />
                    }
                    label="Enabled"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            {data?.metaData && (
              <Grid container direction="row" spacing={2}>
                {data?.metaData?.map((meta) => (
                  <Grid item xs={12}>
                    <DealershipExternalProfileCard data={meta} />
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
          <Grid item>
            <PreferedBrands data={data} handleDataChange={handleDataChange} />
          </Grid>
          <Grid item style={{ height: '80px' }}></Grid>
          <Grid item style={{ position: 'relative' }}>
            <Grid item className={classes.buttonContainer}>
              <Grid container justifyContent="center" alignItems="center">
                <Button variant="contained" className={classes.popCancelBtn} onClick={closePopup}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.popSubmitBtn}
                  onClick={onClickAddNewDealer}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};
